import angular from 'angular';
import MyInstantTicketSalesWidgetComponent from './my-instant-ticket-sales-widget-component';

export default angular
  .module('my-instant-ticket-sales-widget', [])
  .component('myInstantTicketSalesWidget', new MyInstantTicketSalesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-instant-ticket-sales/my-instant-ticket-sales-widget-module.js